// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__34hws","calendarButtons":"ClockData_calendarButtons__1ek3K"};